module.exports = __webpack_public_path__ + "img/suit-12.ab7a0849.png";